import {Stroke, Style, Fill, Circle} from 'ol/style';

const STYLE_DEFAULT = new Style({
  fill: new Fill({
    color: 'rgba(0, 93, 163, 0.2)',
  }),
  stroke: new Stroke({
    color: 'rgb(0 93 163)',
    width: 2,
  }),
  image: new Circle({
    radius: 5,
    fill: new Fill({
      color: 'rgba(0, 93, 163, 0.2)',
    }),
    stroke: new Stroke({
      color: 'rgb(0 93 163)',
      width: 2,
    }),
  }),
});

const STYLE_DELETE = new Style({
  fill: new Fill({
    color: 'rgba(192, 43, 47, 0.7)',
  }),
  stroke: new Stroke({
    color: 'rgba(192, 43, 47, 1)',
    width: 2,
  }),
  image: new Circle({
    radius: 5,
    fill: new Fill({
      color: 'rgba(192, 43, 47, 0.7)',
    }),
    stroke: new Stroke({
      color: 'rgba(192, 43, 47, 1)',
      width: 2,
    }),
  }),
});

const STYLE_EDITING = new Style({
  fill: new Fill({
    color: 'rgba(255, 170, 68, 0.7)',
  }),
  stroke: new Stroke({
    color: 'rgb(255 170 68)',
    width: 2,
  }),
  image: new Circle({
    radius: 5,
    fill: new Fill({
      color: 'rgba(255, 170, 68, 0.7)',
    }),
    stroke: new Stroke({
      color: 'rgb(255 170 68)',
      width: 2,
    }),
  }),
});

const STYLE_HOVER = new Style({
  fill: new Fill({
    color: 'rgba(104, 159, 56, 0.7)',
  }),
  stroke: new Stroke({
    color: 'rgb(104 159 56)',
    width: 2,
  }),
  image: new Circle({
    radius: 5,
    fill: new Fill({
      color: 'rgba(104, 159, 56, 0.7)',
    }),
    stroke: new Stroke({
      color: 'rgb(104 159 56)',
      width: 2,
    }),
  }),
});

const STYLE_HUELLAS_RUIDO = new Style({
  fill: new Fill({
    color: 'rgba(170, 175, 50, 0.4)',
  }),
  stroke: new Stroke({
    color: 'rgba(170, 175, 50, 1)',
    width: 2,
  }),
  image: new Circle({
    radius: 5,
    fill: new Fill({
      color: 'rgba(170, 175, 50, 0.4)',
    }),
    stroke: new Stroke({
      color: 'rgba(170, 175, 50, 1)',
      width: 2,
    }),
  }),
});

const STYLE_ZSA = new Style({
  fill: new Fill({
    color: 'rgba(255, 0, 25, 0.4)',
  }),
  stroke: new Stroke({
    color: 'rgba(255, 0, 25, 1)',
    width: 2,
  }),
  image: new Circle({
    radius: 5,
    fill: new Fill({
      color: 'rgba(255, 0, 25, 0.4)',
    }),
    stroke: new Stroke({
      color: 'rgba(255, 0, 25, 1)',
      width: 2,
    }),
  }),
});

const STYLE_SEARCH = new Style({
  fill: new Fill({
    color: 'rgba(0, 190, 1, 0.2)',
  }),
  stroke: new Stroke({
    color: 'rgb(0, 190, 1)',
    width: 2,
  }),
  image: new Circle({
    radius: 5,
    fill: new Fill({
      color: 'rgba(0, 190, 1, 0.2)',
    }),
    stroke: new Stroke({
      color: 'rgb(0, 190, 1)',
      width: 2,
    }),
  }),
});

const STYLE_SEARCH_HOVER = new Style({
  fill: new Fill({
    color: 'rgba(0, 190, 1, 0.4)',
  }),
  stroke: new Stroke({
    color: 'rgb(0, 190, 1)',
    width: 2,
  }),
  image: new Circle({
    radius: 5,
    fill: new Fill({
      color: 'rgba(0, 190, 1, 0.4)',
    }),
    stroke: new Stroke({
      color: 'rgb(0, 190, 1)',
      width: 2,
    }),
  }),
});

const STYLE_INVISIBLE = new Style({});

export {
  STYLE_DEFAULT,
  STYLE_DELETE,
  STYLE_EDITING,
  STYLE_HOVER,
  STYLE_HUELLAS_RUIDO,
  STYLE_ZSA,
  STYLE_INVISIBLE,
  STYLE_SEARCH,
  STYLE_SEARCH_HOVER,
};
